import { NodeExtension } from "../extension";

export default class TextNode extends NodeExtension {
	get name() {
		return "text";
	}
	get node() {
		return {
			group: "inline",
		};
	}
}
